module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-11"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("L")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("ORELEI")]), _vm._v(" St James came awake with a languorous stretch, sliding her bare arms over silken sheets, revelling sensuously in the luxurious comfort. She made a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘mmph’")]), _vm._v(" sound, rolled over and buried her face in the pillow, prepared to sleep away the day, if that were possible—only to hear a deep male voice raised in anger somewhere outside her bedroom terrace.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Ignore it,")]), _vm._v(" she decided, snuggling in.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The voice lifted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She snuggled a bit more.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("More shouts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She wrinkled her nose.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A crash.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("What now?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sighing, Lorelei pushed her satin sleep mask haphazardly up her forehead and winced as she copped an eyeful of bright Mediterranean sunshine. The room did a rinse-cycle spin around her—no doubt the product of too much champagne, inadequate sleep and enough financial trouble to sink this house around her ears.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She shoved thoughts about the latter to the back of her mind even as her heart began to beat the band, and she felt about for a glass of water to ease the Sahara Desert that was her throat this morning. She was greeted by a clatter as she clumsily knocked her watch, her cell phone and a tangle of assorted jewellery to the stone floor.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Easing herself into a sitting position, pushing the fall of chin-length blond curls out of her eyes, Lorelei wrinkled her nose and held on to the mattress as the room did another gentle spin.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I will never drink again,")]), _vm._v(" she vowed. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Although if I do,")]), _vm._v(" she revised, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only champagne cocktails...and at a pinch G&T’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As if sensing she was at her most vulnerable, the phone on the floor gave a judder and began to vibrate. Her heart did that annoying leap and race thing again. She made a pained face. When the phone rang nowadays there was usually somebody angry on the other end...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("To dissuade her from getting out of bed it stopped, but the muted sound of male voices coming up from below her terrace lifted to a crescendo. This was what had woken her. Men shouting. Some sort of altercation going on.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Surely she didn’t have to deal with this, too? Not today...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But without the catering staff from last night there was only Giorgio and his wife, Terese, and it was unfair to expect them to deal with interlopers. They’d had a lot of them in the past few weeks—all of them creditors, hunting her down now that her father Raymond was banged up in a low-security prison.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("As if she had a cent to her name after two years of legal fees.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It wasn’t that she was exactly ignoring her problems—she preferred to think of it as delegating responsibility. She’d deal with the phone calls later, and the emails and the lawyers who wanted her signature on a mountain of documents. Not today. Maybe tomorrow. It was just such a nice day. The sun was shining. She shouldn’t ruin it. One more day in paradise and then she’d pay the piper.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Just one more day...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then she remembered. Not only did she have a client booked in at noon, she had an appointment this afternoon at the Hotel de Paris. It was about her grandmother’s charity: the Aviary Foundation. Every year they hosted an event to raise money for cancer research.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This year the feature was a one-day vintage car rally, and a famous racing driver would be giving kids struggling with cancer the pleasure of a spin around the track in a high-powered vehicle. Their usual publicist was ill, and the foundation’s president had personally asked her to do the meet-and-greet with their guest celebrity.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She squeezed her temples. She hadn’t even done any research. What if he expected her to know his stats? She could barely balance her own chequebook...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Last year they had lined up a Hollywood actor who famously had a home here in Monaco. Now, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" one would have been easy—watch a few films, gush... Everyone knew actors had egos like mountains. Frowning, she contemplated racing-car drivers. Weren’t they kind of like cowboys? She pictured swagger and ego in equal dimensions. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blah.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Reaching for the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eau de nil")]), _vm._v(" silk evening gown crumpled at the foot of her bed, Lorelei tugged it over her head. Really, she was happy to do the meet-and-greet—she’d do anything the Aviary Foundation asked of her—just not today...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She gave a shriek as something small and furry tunnelled its way onto her lap, claws digging into her flesh.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Fifi,’ she admonished, pulling the silk to her waist, ‘behave, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ma chere.")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lifting her beloved baby, she buried her face in a ball of white fluff.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Now, be good and stay here. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Maman")]), _vm._v(" has things to attend to.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Fifi sat up expectantly in the pool of white silk sheets, curious eyes on her mistress as she opened the French doors and went to step outside. Lorelei doubled back as she remembered she wasn’t wearing any underwear. She wasn’t prudish about her body, but she knew Giorgio was conservative and she didn’t want to embarrass him unnecessarily.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Belting her robe at the waist, Lorelei wandered out onto the terrace. It was going to be another one of those perfect early September days, and she inhaled the briny breeze filled with lavender and rosemary scents from the garden. She most definitely didn’t want to go and sort this out. As she weaved her way down the stone steps, pulling her sunglasses into place, she told herself that whoever it was couldn’t do anything worse than yell at her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But it wasn’t easy being shouted at, and she wondered if she was ever going to become inured to other people’s anger. In her defence, she’d been facing more than her fair share lately—and it wasn’t getting any easier. Maybe she was suffering from overload, because this morning it felt harder than ever. But Giorgio didn’t deserve this either, and the buck had to stop somewhere.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It would just be nice if for once it didn’t stop with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei saw the Bugatti first and her heart sank. How on earth had it ended up in the garden? On second thoughts, she had a pretty good idea...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And then she saw the man who had disturbed her slumber.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was... She was...")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei was vaguely aware that her mouth had formed a little ‘oh’ of wonder. In the next instant she remembered that she hadn’t run a brush through her hair, she wasn’t wearing any make-up and her panties were upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Too late now. He’d spotted her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She couldn’t do anything about her wrinkled evening gown, but she smoothed her sleep-mussed hair, glad of the shades—which this morning were hiding a thousand sins. She tried to remember that even if she wasn’t looking her best she wasn’t without her own certain charm.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Besides, men were so easy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He headed over, all six foot forever of him, with shoulders that would have served a linebacker, a deep chest, a lean waist, tight hips and long, powerful legs—and one of those classically handsome faces that made her think of old-time movie stars.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei knew better than to be a sitting target. She took the initiative and approached the Bugatti, giving her scowling uninvited guest her back view, which she knew—thanks to riding and an hour a day on her Stairmaster—wasn’t bad, and came up with her best line.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Goodness me,’ she drawled, ‘there’s a car in my rose bushes.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("On the other hand, maybe humour hadn’t been the best direction to take this in. As she listened to the crunch of gravel—big, heavy male footsteps coming up behind her—Lorelei experienced that sinking feeling: the one that told her she’d read the situation all wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Giorgio’s expression told her to duck and cover, but after a brief, desperate glance at the older man she decided to stay where she was. It wasn’t her style to cut and run, and she’d come this far—she just needed to brazen it out. And the guy had stopped shouting, which was encouraging.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Are you responsible for this?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei took in three things. He was Australian, he had a voice that made Russell Crowe sound like a choirboy, and—as she turned around and looked up into a set masculine face—he clearly wasn’t in any mood to be amused or charmed. She couldn’t blame him. The car did look pretty bad.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Are")]), _vm._v(" you?’ he repeated, snapping off his aviators and revealing a pair of spectacular eyes—navy blue rimmed with grey, surrounded by dense, thick, dark lashes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Those eyes. They were sort of..."), _c('em', {
    staticClass: "italic"
  }, [_vm._v("amazing.")]), _vm._v(" Lorelei couldn’t help gazing helplessly back.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Except they pinned her like a blade to a dissection board. She could almost "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("feel")]), _vm._v(" him deciding which part of her to excise first. She came back to earth with a thump and tried to ignore the pinch in her chest. It was a look she was becoming depressingly familiar with of late, and it didn’t mean anything, she told herself. She would have thought she’d be used to it by now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He shoved the aviators into the back pocket of his jeans and settled his arms by his sides—stance widened, pure masculine intimidation.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Anything to say for yourself?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He was pumping out lots of frustrated testosterone, which was making her a little nervous, but she couldn’t really blame him. He wanted another man to punch on the nose and he’d got her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He clearly didn’t know what to do about that.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She lifted a trembling hand and smoothed down her hair.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘Are you "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("high,")]), _vm._v(" lady?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei was so busy staying her ground that his questions hadn’t quite penetrated, but now that he was turning away the last one landed on her with a thump.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Pardon?’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But the guy was already focussing his entire attention back on the car, his hands on those lean, muscled hips of his as he eyed the Bugatti nose-deep in the rose bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Giorgio was muttering in Italian, and the guy said something to him in his own language. Before her eyes the men appeared to be bonding over their shared outrage about the car. Freed from that penetrating stare, Lorelei frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Well, really.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("This wasn’t how the man-meets-Lorelei scenario was supposed to play out. Her Italian was minimal, at best, and she didn’t like the feeling of being forcibly held at bay by her inability to understand what was being said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She was also a little piqued at being ignored.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And she most definitely didn’t like being intimidated.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She cocked a hip, one slender hand resting just below her waist.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘So, do you think you can extract it before it does any more damage to my flowers?’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Giorgio muttered something like, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Madonna!’")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Good—now she’d get a little action.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The man’s broad shoulders grew taut, and as he turned around she felt her bravado flicker uneasily. His movements were alarmingly deliberate—as if this was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" estate, Giorgio "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" employee and she was trespassing on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" land. A stone-cold stare slammed into her. He suddenly seemed awfully big, and Lorelei knew in that instant he wasn’t amused, he wasn’t charmed and he wasn’t going to be easy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘As far as I’m concerned, lady,’ he said, his expression giving no ground, ‘you’re screwed.’")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Her reaction was fierce and immediate. She "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hated")]), _vm._v(" this feeling. She’d been dealing with it for too long. It felt as if all she’d done lately was shoulder the blame. So this time it was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" fault, but for some reason his anger felt disproportionate and just plain unfair. It was too much, coming on top of everything else.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Who cared about a silly car when her life was coming apart at the seams?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("So she did what she always did when a man challenged her, called her to account or tried to make himself king of her mountain. She brought out the big guns. The ones she’d learned from her beloved, irresponsible father.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wit and sex appeal.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lorelei dipped her glasses and gave him full wattage.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("‘I can hardly wait,’ she purred.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-9"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-623409d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 78
// module chunks = 0